<template>
  <div class="mx-auto w-full max-w-7xl px-4 pb-16 pt-10 md:px-8 md:pt-16">
    <header class="mb-8">
      <p class="text-xs uppercase tracking-[0.3em] text-[var(--accent)]">{{ $t('cyberPage.kicker') }}</p>
      <h1 class="mt-3 text-3xl font-bold text-[var(--text-primary)] md:text-5xl">{{ $t('cyberPage.title') }}</h1>
      <p class="mt-4 max-w-3xl text-[var(--text-muted)]">
        {{ $t('cyberPage.subtitle') }}
      </p>
    </header>

    <section class="grid gap-6 lg:grid-cols-2">
      <article class="panel p-6">
        <h2 class="text-xl font-bold text-[var(--text-primary)]">{{ $t('cyberPage.capabilitiesTitle') }}</h2>
        <ul class="mt-4 space-y-3 text-sm text-[var(--text-secondary)]">
          <li v-for="item in content.capabilities" :key="item" class="flex gap-3">
            <span class="mt-2 h-1.5 w-1.5 rounded-full bg-[var(--accent)]" />
            <span>{{ $t(item) }}</span>
          </li>
        </ul>
      </article>

      <article class="panel p-6">
        <h2 class="text-xl font-bold text-[var(--text-primary)]">{{ $t('cyberPage.architectureTitle') }}</h2>
        <p class="mt-2 text-sm text-[var(--text-muted)]">{{ $t('cyberPage.architectureSubtitle') }}</p>
        <div class="mt-4 space-y-3">
          <div
            v-for="row in content.architecture"
            :key="row.labelKey"
            class="rounded-xl border border-[var(--border)] bg-[var(--chip-bg)] px-4 py-3"
          >
            <p class="text-xs uppercase tracking-[0.2em] text-[var(--accent)]">{{ $t(row.labelKey) }}</p>
            <p class="mt-1 text-sm text-[var(--text-secondary)]">{{ $t(row.valueKey) }}</p>
          </div>
        </div>
      </article>
    </section>

    <section id="cyber-case-studies" class="mt-8 panel p-6">
      <h2 class="text-xl font-bold text-[var(--text-primary)]">{{ $t('cyberPage.caseTitle') }}</h2>
      <div class="mt-4 grid gap-4 md:grid-cols-2">
        <article
          v-for="caseStudy in content.caseStudies"
          :key="caseStudy.titleKey"
          class="rounded-xl border border-[var(--border)] bg-[var(--chip-bg)] p-5"
        >
          <h3 class="text-base font-semibold text-[var(--text-primary)]">{{ $t(caseStudy.titleKey) }}</h3>
          <p class="mt-2 text-sm text-[var(--text-muted)]"><strong class="text-[var(--text-secondary)]">{{ $t('projectsPage.labels.problem') }}:</strong> {{ $t(caseStudy.problemKey) }}</p>
          <p class="mt-2 text-sm text-[var(--text-muted)]"><strong class="text-[var(--text-secondary)]">{{ $t('projectsPage.labels.approach') }}:</strong> {{ $t(caseStudy.approachKey) }}</p>
          <p class="mt-2 text-sm text-[var(--accent)]"><strong>{{ $t('projectsPage.labels.outcome') }}:</strong> {{ $t(caseStudy.outcomeKey) }}</p>
        </article>
      </div>
    </section>

    <section class="mt-8 panel p-6">
      <h2 class="text-xl font-bold text-[var(--text-primary)]">{{ $t('cyberPage.references.title') }}</h2>
      <p class="mt-2 text-sm text-[var(--text-muted)]">{{ $t('cyberPage.references.subtitle') }}</p>
      <div class="mt-4 flex flex-wrap gap-2">
        <router-link
          v-for="ref in references"
          :key="ref.labelKey"
          :to="ref.to"
          class="rounded-full border border-[var(--border)] px-3 py-1 text-xs text-[var(--accent)] hover:underline"
        >
          {{ $t(ref.labelKey) }}
        </router-link>
      </div>
    </section>
  </div>
</template>

<script>
import { CYBERSECURITY_SECTIONS } from '@/constants/domainContent';

export default {
  name: 'CybersecurityPage',
  data() {
    return {
      content: CYBERSECURITY_SECTIONS,
      references: [
        { to: '/projects#project-athack', labelKey: 'cyberPage.references.items.athack' },
      ],
    };
  },
};
</script>
